export const openFeaturebaseFeedbackWidget = () =>
  window.postMessage({
    target: "FeaturebaseWidget",
    data: {
      action: "openFeedbackWidget",
    },
  });
